module.exports = __webpack_public_path__ + "static/media/a270eafb.jpg";